module.exports = __webpack_public_path__ + "img/b6.4f28d2ce.png";